import moment from "moment";
import { chain, random } from "lodash";

import mockSummary from "./mock/mockSummary.json";
import mockCoordinates from "./mock/mockCoordinates.json";

export const robots_with_coordinates = mockCoordinates.map((item) => {
  const swr_information = mockSummary.find((i) => {
    if (i.key === "SWR-185") {
      return (i.key === "SWR-185") === (item.name === "SWR-1805");
    } else if (i.key === "SWR-1914B") {
      return (i.key === "SWR-1914B") === (item.name === "SWR-1914");
    } else {
      return i.key === item.name;
    }
  });

  return {
    ...item,
    swr_information:
      (swr_information && swr_information.unit_summary.slice(3)) || [],
  };
});

const today = moment();

const eventsList = [
  "Software Upgrade",
  "Site Visit",
  "Training",
  "Installation",
];

const generate_events = () =>
  chain([...Array(30)])
    .map((item) => {
      return {
        date: moment(today)
          .subtract(random(-10, 10), "day")
          .format("YYYY-MM-DD"),
        name:
          robots_with_coordinates[random(0, robots_with_coordinates.length - 1)]
            .name,
        event: eventsList[random(0, eventsList.length - 1)],
      };
    })
    .orderBy(({ date }) => date, "asc")
    .value();

export const upcoming_events = generate_events();
